function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    const	head = document.getElementsByTagName('head')[0]
    script.type = 'text/javascript'
    script.charset = 'UTF-8'
    script.src = src
    if (script.addEventListener) {
      script.addEventListener('load', () => {
        resolve()
      }, false)
    } else if (script.attachEvent) {
      script.attachEvent('onreadystatechange', () => {
        const target = window.event.srcElement
        if (target.readyState === 'loaded') {
          resolve()
        }
      })
    }
    head.appendChild(script)
  })
}
function wxConfig(config) {
  // eslint-disable-next-line no-undef
  wx.config({
    debug: false,
    appId: config.appId,
    timestamp: config.timestamp,
    nonceStr: config.nonce_str,
    signature: config.signature,
    jsApiList: [
      'updateAppMessageShareData', 'updateTimelineShareData', 'getLocation'
    ]
  })
}
function initWxShare(config, option) {
  return new Promise((resolve) => {
    // 初始化
    if (!option) option = {}
    const { title } = option
    const summary = option.cont
    const link = option.url ? option.url : location.href
    const thumb = option.logo
    const content = {
      title,
      desc: summary,
      link,
      imgUrl: thumb,
      success() {
        if (option.success) {
          option.success()
        }
      },
      cancel() {
      }
    }
    // eslint-disable-next-line no-undef
    wx.ready(() => {
      // eslint-disable-next-line no-undef
      wx.updateTimelineShareData(content)
      // eslint-disable-next-line no-undef
      wx.updateAppMessageShareData(content)
      resolve()
    })
  })
}
export function wxShare(option, config) {
  return new Promise((resolve) => {
    loadScript('http://res.wx.qq.com/open/js/jweixin-1.6.0.js')
      .then(() => initWxShare(config, option))
      .then(() => resolve())
  })
}
export function initWx(config) {
  return new Promise((resolve) => {
    loadScript('http://res.wx.qq.com/open/js/jweixin-1.6.0.js')
      .then(() => {
        wxConfig(config)
        resolve()
      })
  })
}
export function wxStop() {}
